export const CLEANUP_ENTERPRISE_INVITE = 'cleanup-enterprise_invite';
const cleanupEnterpriseInvite = () => ({ type: CLEANUP_ENTERPRISE_INVITE });
export default cleanupEnterpriseInvite;
